import React from "react";
import "./about.css";
import Me from "../../assets/yol.png";
import { FaAward } from "react-icons/fa";
import { VscFolderLibrary } from "react-icons/vsc";

const About = () => {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={Me} alt="Eric Stéfano" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>2 Year on Web Development (Academic/Work)</small>
            </article>
            <article className="about__card">
              <VscFolderLibrary className="about__icon" />
              <h5>Projects</h5>
              <small>Worked on 10+ Projects</small>
            </article>
          </div>

          <p>
            I'm a dreamer, a hardworker and especially a curious person. My skill set is usually more broadly focused because I really like to understand 
            the most I can about the environment I'm working in/studying about. My experience with personal projects is focused especially in React and Node + MongoDB, whereas my working experience is mainly focused on WordPress Theme Development and PHP/Laravel + React/Vanilla JS/Vue.
          </p>
          <p>
            I started freelancing at february, and since April I've been working at a startup. I'm used to agile methodologies and following the git flow, and I like helping my team whenever I can. I'm looking for a new job because - like I previously said - I'm a dreamer, and I'm not afraid to put on hard work to get where I want.
          </p>

          <a
            href="#contact-me"
            className="box-btn btn-primary about__contact-btn"
          >
            Let's talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
